import { Flex, Box } from '@chakra-ui/react';
import { ICompanyGroups } from 'pages/UserManagement/types';
import { linkStyle } from 'shared/styles';

const ALinkCell = ({
    row: { original },
    linkCTA,
}: {
    row: { original: ICompanyGroups };
    linkCTA: (companyGroup: ICompanyGroups) => void;
}) => {
    return (
        <Flex>
            <Box {...linkStyle} onClick={() => linkCTA(original)} color="blue.500">
                {original.name}
            </Box>
        </Flex>
    );
};
export default ALinkCell;
